import { sha256 } from 'js-sha256';

type CartSelectionIdentityInput = {
  authenticated: boolean;
  userId?: string | number | null;
  visitorId?: string | null;
  /** 仅由已结束账户初始化的调用方传入，用于资料失败时隔离当前会话。 */
  token?: string | null;
};

/** 复用既有用户/访客身份；快照和加购凭据不保存原始 ID、token 或个人资料。 */
export function resolveCartSelectionIdentity({
  authenticated,
  userId,
  visitorId,
  token,
}: CartSelectionIdentityInput): string | null {
  if (authenticated) {
    const id = String(userId ?? '');
    if (!/^[1-9]\d*$/.test(id) || !Number.isSafeInteger(Number(id))) {
      return token ? `session:${sha256(`token:${token}`)}` : null;
    }
    return `user:${sha256(`user:${id}`)}`;
  }
  if (typeof visitorId !== 'string' || !visitorId.trim()) return null;
  return `visitor:${sha256(`visitor:${visitorId}`)}`;
}
